import { PRODUCT_SORTING } from 'swag-common/constants/product.constants';
export const MENU_ITEMS = [{
  name: PRODUCT_SORTING.MOST_POPULAR,
  isForClient: false
}, {
  name: PRODUCT_SORTING.NEWEST,
  isForClient: true
}, {
  name: PRODUCT_SORTING.HOTTEST,
  isForClient: true
}, {
  name: PRODUCT_SORTING.HIGHEST_PRICE,
  isForClient: false
}, {
  name: PRODUCT_SORTING.LOWEST_PRICE,
  isForClient: false
}];